// extracted by mini-css-extract-plugin
export default {"main":"_4efb4de890","tit":"d3d5071c02","maintitle":"d4146ea21f","ylw":"f93c76b0cd","white":"f87429f5ad","mv_title":"_27dafd6d4f","mv_nc":"a6ce3201ac","mv_in":"bd31812121"};